import React from 'react'

export default function SebetSvg({ fill = "#fff" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={25}
            height={24}
            fill="none"
        >
            <path
                fill={fill}
                d="M2.48 2.204c-.416 0-.836.002-1.257 0C.553 2.201.018 1.741 0 1.155-.016.581.498.047 1.147.023a33.53 33.53 0 0 1 2.25-.008c.62.02 1.026.388 1.156.973.3 1.364.606 2.726.897 4.092.063.297.188.41.526.409 5.87-.012 11.74-.01 17.61-.012 1.14 0 1.606.605 1.343 1.678-.416 1.7-.79 3.408-1.186 5.113-.23.988-.44 1.981-.717 2.958-.37 1.316-1.663 2.263-3.088 2.271-2.917.016-5.835.006-8.751.007-.812 0-1.624-.038-2.433.006-1.574.084-3.138-1.065-3.479-2.73-.326-1.596-.697-3.183-1.048-4.774-.499-2.262-.997-4.523-1.498-6.784-.073-.328-.16-.654-.25-1.018Zm3.6 5.489c.007.122 0 .205.018.282.476 2.126.95 4.251 1.435 6.376.16.703.523.968 1.279.969 3.594.002 7.188.002 10.782.002.818 0 1.2-.304 1.373-1.06.444-1.945.892-3.888 1.337-5.833.054-.233.098-.468.153-.736H6.079ZM9.866 21.744C9.851 23.03 8.832 24.017 7.536 24c-1.313-.018-2.294-1.03-2.274-2.349.019-1.207 1.083-2.207 2.332-2.192 1.267.017 2.287 1.043 2.273 2.285ZM20.73 19.46c1.268 0 2.299 1.016 2.297 2.262 0 1.247-1.027 2.268-2.288 2.278-1.256.01-2.325-1.029-2.317-2.249a2.285 2.285 0 0 1 2.308-2.292Z"
            />
        </svg>
    )
}
